import {
    ClickElement,
    ClickText,
    EventCategory,
    GA4EventName,
    GA4FeatureCategory,
    trackAnalyticsEvent,
} from '@jsmdg/tracking';

async function trackTabSwitched(label: string, caption: string): Promise<void> {
    await window.yieldToMainThread();
    trackAnalyticsEvent({
        category: 'ProductDetail',
        action: 'TabClick',
        label,
        eventData: {
            eventName: GA4EventName.ClickTab,
            feature_category: GA4FeatureCategory.ProductDetailInformation,
            click_element: label,
            click_text: caption,
        },
    });
}

async function trackMapClicked(): Promise<void> {
    await window.yieldToMainThread();
    trackAnalyticsEvent({
        category: EventCategory.ProductDetail,
        action: 'Map',
        label: 'CloseUp',
        eventData: {
            eventName: GA4EventName.OpenMap,
            feature_category: GA4FeatureCategory.ProductDetailInformation,
            click_element: ClickElement.MapInDescription,
            click_text: ClickText.MapViewBig,
        },
    });
}

async function trackExpandCountryLocationsClicked(
    countryCode: string | undefined,
    country: string,
): Promise<void> {
    if (countryCode) {
        await window.yieldToMainThread();
        trackAnalyticsEvent({
            category: 'ProductDetail',
            action: 'Map',
            label: `Expand_${country}`,
        });
    }
}

export { trackExpandCountryLocationsClicked, trackMapClicked, trackTabSwitched };
